module.exports = __webpack_public_path__ + "img/selected7-min.9b6c7ba7.png";